import { inject } from '@angular/core';
import { GlobalStateService } from './global-state.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from 'node_modules/@azure/msal-browser/dist/utils/BrowserConstants';
import { firstValueFrom, startWith, filter, take } from 'rxjs';
import { ExcelHelperService } from '../addin-helper-services/excel-helper.service';
import { initializeSortCommands } from '../addin-helper-services/sort-commands';

/**
 * Factory function to initialize the global state & MSAL.
 * Angular will wait for the returned promise before completing the app initialization.
 */
export const initializeGlobalState = async (): Promise<void> => {
  // Inject all services at the beginning (within injection context)
  const broadcast = inject(MsalBroadcastService);
  const msal = inject(MsalService);
  const configService = inject(GlobalStateService);
  const excelHelper = inject(ExcelHelperService);

  await msal.initialize();

  // we wait for the first "None" status, then grab the account
  await firstValueFrom(
    broadcast.inProgress$.pipe(
      startWith(InteractionStatus.None),
      filter((status) => status === InteractionStatus.None),
      take(1)
    )
  );

  // Global
  await Office.onReady();
  await configService.setWorkpaperContextData();

  // Initialize sort commands with ExcelHelperService
  // Note: The Office.actions are already registered when sort-commands.ts is imported.
  // This just provides the ExcelHelperService instance for the command handlers.
  initializeSortCommands(excelHelper, configService);
};

// DO NOT REMOVE THIS. Have this code for reference - Need it for refactoring.
// this.subs.add(
//   this.broadcastService.inProgress$
//     .pipe(
//       filter(
//         (status: InteractionStatus) => status === InteractionStatus.None
//       )
//     )
//     .subscribe(() => {
//       const account: Profile | undefined =
//         this.msalService.instance.getAllAccounts()[0];

//       if (account) {
//         this.loggedinUser = account?.idTokenClaims?.name;
//       }
//     })
// );
